module.exports = __webpack_public_path__ + "img/competencies_swiper_05.e965edfd.jpg";